import { functionMemberPeriodDto, IFunctionMemberPeriodDto } from 'src/assets/common/models/function-member-period-dto.g';
import { momentPassed } from 'src/app/infrastructure/functions/zone-day.function';

// Eén aan/uit-periode van een FunctionMember (plan A "FunctionMember-periodes"), nieuwste eerst
// aangeleverd door de backend. startDate/endDate = kalenderdagen ('yyyy-MM-dd') in de zone van
// domain/project, endDate = laatste dag mét toegang; null = lopend. endMoment = het exclusieve eindmoment
// (UTC) voor "open". fullDays = volle dagen in de zone (dezelfde telling als straks de creditafrekening).
export interface IFunctionMemberPeriod {
    guid: string;
    startDate: string | null;
    endDate: string | null;
    endMoment: string | null;
    endReason: TFunctionMemberPeriodEndReason | null;
    fullDays: number;
}

export const functionMemberPeriodEndReason = {
    unchecked: 'Unchecked',
    membershipEnded: 'MembershipEnded',
    projectClosed: 'ProjectClosed',
    deleted: 'Deleted',
} as const;

export type TFunctionMemberPeriodEndReason = (typeof functionMemberPeriodEndReason)[keyof typeof functionMemberPeriodEndReason];

export const functionMemberPeriodEndReasonLabel: Record<TFunctionMemberPeriodEndReason, string> = {
    [functionMemberPeriodEndReason.unchecked]: 'uitgezet',
    [functionMemberPeriodEndReason.membershipEnded]: 'lidmaatschap beëindigd',
    [functionMemberPeriodEndReason.projectClosed]: 'project gesloten',
    [functionMemberPeriodEndReason.deleted]: 'verwijderd',
};

export function functionMemberPeriod_map(dto: IFunctionMemberPeriodDto): IFunctionMemberPeriod {
    return {
        guid: dto[functionMemberPeriodDto.guid] ?? '',
        startDate: dto[functionMemberPeriodDto.startDay],
        endDate: dto[functionMemberPeriodDto.endDay],
        endMoment: dto[functionMemberPeriodDto.endDate],
        endReason: dto[functionMemberPeriodDto.endReason] as TFunctionMemberPeriodEndReason | null,
        fullDays: dto[functionMemberPeriodDto.fullDays] ?? 0,
    };
}

export function functionMemberPeriods_map(dtos: IFunctionMemberPeriodDto[] | null | undefined): IFunctionMemberPeriod[] {
    return (dtos ?? []).map(functionMemberPeriod_map);
}

// Open = nog lopend of met een eindmoment in de toekomst (zelfde check als de backend, zie ZoneClock).
export function functionMemberPeriod_isOpen(period: IFunctionMemberPeriod): boolean {
    return !period.endMoment || !momentPassed(period.endMoment);
}
